var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FilledInput } from '@mui/material';
import useSSearchInputStyles from './useSSearchInputStyles';
import { useTranslation } from "react-i18next";
import React from 'react';
import { SearchNormal1 } from 'iconsax-react';
const SSearchInput = (_a) => {
    var { sx } = _a, rest = __rest(_a, ["sx"]);
    const { t } = useTranslation(['common', 'form', 'validation']);
    const { searchbarStyles } = useSSearchInputStyles();
    return (React.createElement(FilledInput, Object.assign({ className: 'searchbar', disableUnderline: true, "aria-placeholder": t("form:placeholders.searchHere"), placeholder: t("form:placeholders.searchHere"), sx: [
            searchbarStyles,
            {
                height: '53px',
                width: '100%',
                '& input': {
                    padding: '10 12px',
                }
            },
            ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
        ], size: 'small' }, rest, { endAdornment: React.createElement(SearchNormal1, { fontSize: 20 }) })));
};
export default SSearchInput;
